export const detailedLFV1 = ["OriginalAsIsLtv", "OriginalLtc"];

export const detailedPropPLFV1 = [
  "ESRIPopulationDensity",
  "ZillowCBSA",
  "AdjustedAsIsValue",
];
